// Hàng thứ 2: số người theo hạng (thanh ngang có màu từng hạng) + ngân sách đã dùng / trần.
import { Card, Col, Progress, Row } from "antd";
import XuEmptyHint from "./xu-empty-hint";
import { fmtNum, fmtPct, tierHex } from "./xu-format-helpers";

function RankBars({ tiers }) {
    const total = tiers.reduce((s, t) => s + t.users, 0);
    if (!total) return <XuEmptyHint compact title="Chưa có ai được tính hạng" hint="Hạng chỉ tính cho đơn đã duyệt sau ngày ra mắt hạng. Đặt ngày ở tab Cấu hình → Hạng." />;
    return (
        <div className="space-y-3">
            {tiers.map((t) => {
                const p = (t.users / total) * 100;
                return (
                    <div key={t.tier}>
                        <div className="flex justify-between text-sm mb-1">
                            <span className="font-medium"><span className="inline-block w-2.5 h-2.5 rounded-full mr-2" style={{ background: tierHex(t.tier) }} />{t.name}</span>
                            <span><b>{fmtNum(t.users)}</b> người <span className="text-gray-400">({fmtPct(Math.round(p * 10) / 10)})</span></span>
                        </div>
                        <Progress percent={p} showInfo={false} strokeColor={tierHex(t.tier)} size="small" />
                    </div>
                );
            })}
            <div className="text-xs text-gray-400">Chỉ đếm người đã được tính hạng; người chưa có dữ liệu mặc định ở hạng 1.</div>
        </div>
    );
}

/** Một thanh ngân sách; trần null ⇒ "Không giới hạn". */
function BudgetBar({ label, used, cap }) {
    const p = cap ? Math.min(100, Math.round((used / cap) * 100)) : 0;
    return (
        <div>
            <div className="flex justify-between text-sm mb-1">
                <span className="font-medium">{label}</span>
                <span><b>{fmtNum(used)}</b> / {cap ? `${fmtNum(cap)} Xu` : "Không giới hạn"}</span>
            </div>
            {cap ? <Progress percent={p} size="small" status={p >= 100 ? "exception" : p >= 80 ? "active" : "normal"} /> : <Progress percent={0} size="small" showInfo={false} />}
        </div>
    );
}

export default function XuStatsRankAndBudget({ stats }) {
    const { budget } = stats;
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
                <Card size="small" title="Số người theo từng hạng" className="shadow-sm h-full"><RankBars tiers={stats.tiers} /></Card>
            </Col>
            <Col xs={24} lg={12}>
                <Card size="small" title="Ngân sách Xu đã dùng" className="shadow-sm h-full">
                    <div className="space-y-4">
                        <BudgetBar label="Hôm nay" used={budget.usedDaily} cap={budget.daily} />
                        <BudgetBar label="Tháng này" used={budget.usedMonthly} cap={budget.monthly} />
                        <div className="text-xs text-gray-400">Chạm trần thì nhiệm vụ mới tạm dừng phát Xu. Đổi trần ở tab Cấu hình → Ngân sách.</div>
                    </div>
                </Card>
            </Col>
        </Row>
    );
}
